import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { HintErrorComponent } from '@vg-constellation/angular-16/hint-error';
import { InputComponent, InputInputComponent } from '@vg-constellation/angular-16/input';
import { LabelComponent } from '@vg-constellation/angular-16/label';
import { IMaskModule } from 'angular-imask';

@Component({
  selector: 'app-gift-amount-input',
  templateUrl: './gift-amount-input.component.html',
  styleUrls: ['./gift-amount-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LabelComponent,
    InputComponent,
    InputInputComponent,
    IMaskModule,
    HintErrorComponent,
  ],
})
export class GiftAmountInputComponent {
  @Input() content: any;
  @Input() parentForm: UntypedFormGroup;
  @Input() errorMsg: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() label: string;
  @Input() inputMask: string;
  @Input() stepNumber: string;
  @Input() controlName: string;
  @Input() showError: boolean;

  get amountInputHasError(): boolean {
    return (
      this.parentForm.controls[this.controlName].invalid &&
      (this.parentForm.controls[this.controlName].touched || this.showError)
    );
  }
}
